// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"e9204dfa","151":"af7863c4","221":"dd97c800","402":"5d636aac","442":"550505f2","653":"b6530831","690":"2854b9a9","754":"f2c7ee6f"}[chunkId] + ".chunk.js";
};